<template lang="pug">
  div
    v-layout(align-center, justify-space-between)
      v-flex(xs4)
        span(class="headline") Sites
      v-flex(xs4)
        div(class="text-xs-right")
          | These sites are pulled from Zabbix's database.

    v-container(style="padding-top: 0;")
      v-layout(v-show="loading" class="mt-5" justify-center)
        v-progress-circular(size="50" indeterminate)

      v-layout(v-show="!loading && sites.length === 0"
               class="mt-5"
               justify-center)
        span(class="title") No sites.

      div(v-show="!loading && sites.length > 0")
        v-layout(justify-center)
          v-flex(xs4)
            v-text-field(
              v-model="search"
              ref="input"
              append-icon="search"
              class="ma-0"
              hide-details
              label="Find a site"
              @input="selected = 0"
              @keypress.down.right.tab.prevent="selectNext"
              @keypress.up.left="selectPrevious"
              @keypress.enter="gotoSelected")
        v-layout(class="mt-3")
          v-flex
            v-data-table(
              :custom-filter="filter"
              :headers="headers"
              :items="sites"
              :pagination.sync="pagination"
              :rows-per-page-items="[20, 100, 1000, {'text':'All','value':-1}]"
              :search="search"
              hide-actions
              hide-headers)
              template(
                slot="items"
                slot-scope="props")
                  tr(:active="selected === props.index")
                    td
                      router-link(
                        :to="{ name: 'site', params: { id: props.item.id } }"
                        class="clickable") {{ props.item.id }}
        v-layout(justify-center class="mt-3")
          v-flex(xs6)
            div(class="text-xs-center")
              v-pagination(v-model="pagination.page"
                           :length="pages"
                           color="grey darken-2")

</template>

<script>
export default {
  name: "sites",
  data () {
    return {
      headers: [
        {
          sortable: false,
          text: "ThinxtraID",
          value: "id"
        }
      ],
      loading: false,
      search: "",
      selected: 0,
      sites: [],
      pagination: { rowsPerPage: 20, totalItems: 0 }
    };
  },
  computed: {
    pages () {
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage);
    }
  },
  mounted () {
    this.loading = true;
    this.$http.
      get("/api/sites").
      then((r) => {
        for (const site of r.data) {
          this.sites.push(site);
          this.pagination.totalItems += 1;
        }
        this.selected = 0;
        this.loading = false;
        this.$nextTick(() => this.$refs.input.focus());
      }).
      catch(() => this.loading = false);
  },
  methods: {
    selectNext () {
      this.selected += 1;
    },
    selectPrevious () {
      if (this.selected > 0) {
        this.selected -= 1;
      }
    },
    gotoSelected () {
      this.$router.push({
        name: "site",
        params: {
          id: this.
            filter(this.sites, this.search)[
              this.selected +
              this.pagination.rowsPerPage * (this.pagination.page - 1)
            ].
            id
        }
      });
    },
    filter (items, search) {
      return items.filter((site) => site.id.indexOf(search.toUpperCase()) > -1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sites.vue